import { lazy, Suspense } from 'react';
import { useActivityBar } from '../contexts/ActivityBarContext';

// Maps an activity "type" key to the modal component that knows how to render
// it. Add new entries here as more modals opt into Modal UI v2's Activity Bar.
const ACTIVITY_MODAL_REGISTRY = {
  customer_management: lazy(() => import('./ContactNotesTasksModal').then(m => ({ default: m.ContactNotesTasksModal }))),
  project_management: lazy(() => import('./ProjectManagementModal').then(m => ({ default: m.ProjectManagementModal }))),
  add_to_crm: lazy(() => import('./AddToCrmModal').then(m => ({ default: m.AddToCrmModal }))),
  add_call_to_crm: lazy(() => import('./AddCallToCrmModal').then(m => ({ default: m.AddCallToCrmModal }))),
  schedule_call: lazy(() => import('./ScheduleCallModal').then(m => ({ default: m.ScheduleCallModal }))),
  stock_request: lazy(() => import('./StockRequestModal').then(m => ({ default: m.StockRequestModal }))),
  proforma: lazy(() => import('../pages/Proforma').then(m => ({ default: m.default.Modal }))),
  quote: lazy(() => import('../pages/Quotes').then(m => ({ default: m.default.Modal }))),
  eight_by_eight_calls: lazy(() => import('./EightXEightCallsBar').then(m => ({ default: m.EightXEightCallsModal }))),
  b29_transfer: lazy(() => import('../pages/B29StockTransfer').then(m => ({ default: m.default.Modal }))),
};

/**
 * Mounted once, globally (see App.js), outside the page router tree. When a
 * user reopens an "Open Activities" or "Recent Activities" tab from ANY
 * page, this is what actually renders the modal again (since the page that
 * originally opened it may no longer be mounted) — driven purely by
 * ActivityBarContext's `activeActivity`, resuming from its saved snapshot.
 */
export const ActivityModalHost = () => {
  const { activeActivity, discardActive } = useActivityBar();

  if (!activeActivity?.renderedByHost) return null;
  const ModalComponent = ACTIVITY_MODAL_REGISTRY[activeActivity.type];
  if (!ModalComponent) return null;

  return (
    <Suspense fallback={null}>
      <ModalComponent
        isOpen={true}
        onClose={discardActive}
        resumeSnapshot={activeActivity.snapshot}
      />
    </Suspense>
  );
};

export default ActivityModalHost;
